import "./lib/layerSwitcherUX.js";
import "./lib/registerSW.js";
import { renderPWAShell } from "./components/PWAShell.jsx";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "leaflet/dist/leaflet.css";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

// PWA shell (BottomNav + InstallPrompt) — portal mount, geen App.jsx mod nodig
renderPWAShell();

// Patch #35: optionally toon de sticky-head als de user 'm terug wil
try {
  if (localStorage.getItem("pv.show_sb_head") === "1") {
    document.body.classList.add("sb-show-head");
  }
} catch (e) {}
